import { rem } from 'polished';
import styled from 'styled-components';

export const StyledModalBodyWrapper = styled.section`
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 80%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: ${rem('563px')};
`;
